module.exports = {
	"name": "floorplan",
	"version": "0.1.4",
	"private": true,
	"licence": "UNLICENCED",
	"author": "Gustavo Reis",
	"email": "gustavo.reis@informa.com",
	"engines": {
		"node": "^8.0.0"
	},
	"devDependencies": {
		"@kadira/storybook": "^2.21.0",
		"@kadira/storybook-addon-knobs": "^1.7.1",
		"@kadira/storybook-addon-notes": "^1.0.1",
		"@kadira/storybook-addon-options": "^1.0.1",
		"@kadira/storybook-addons": "^1.6.1",
		"concurrently": "^3.1.0",
		"eslint": "^3.9.0",
		"eslint-config-airbnb": "^12.0.0",
		"eslint-plugin-flowtype": "^2.25.0",
		"eslint-plugin-import": "^2.0.1",
		"eslint-plugin-jsx-a11y": "^2.2.3",
		"eslint-plugin-react": "^6.4.1",
		"react-scripts": "0.7.0"
	},
	"dependencies": {
		"apollo-client": "^0.5.9",
		"flow-bin": "^0.37.4",
		"futuremaster": "^1.2.8",
		"graphql-tag": "^1.1.2",
		"react": "^15.3.2",
		"react-apollo": "^0.7.1",
		"react-dom": "^15.3.2",
		"react-ga": "^2.1.2",
		"react-intl": "^2.2.3",
		"react-intl-redux": "^0.3.0",
		"react-lazyload": "^2.1.6",
		"react-motion": "^0.4.5",
		"react-motion-ui-pack": "^0.10.2",
		"react-redux": "^5.0.1",
		"react-router": "^3.0.0",
		"react-router-redux": "^4.0.7",
		"recompose": "^0.20.2",
		"redux": "^3.6.0",
		"semantic-ui-react": "^0.56.13",
		"stylus": "^0.54.5"
	},
	"scripts": {
		"start": "concurrently -k -r \"react-scripts start\" \"yarn run styles\"",
		"staging": "yarn run build && cd build && cp index.html 200.html && surge . plantabaixa.surge.sh",
		"deploy": "yarn run build && cd build && cp index.html 200.html && surge . floorplan.futurecom.com.br",
		"deploy-storybook": "build-storybook -c .storybook -o .out && cd .out && cp index.html 200.html && surge . futureaccounts-storybook.surge.sh",
		"build": "react-scripts build",
		"test": "react-scripts test --env=jsdom",
		"eject": "react-scripts eject",
		"storybook": "concurrently -k -r \"start-storybook -p 9009 -s public\" \"yarn run styles\"",
		"build-storybook": "build-storybook -s public",
		"styles": "stylus -w stylus/styles.styl -o src/assets/bundled-styles.css"
	}
};


/*****************
 ** WEBPACK FOOTER
 ** ./package.json
 ** module id = 1655
 ** module chunks = 0
 **/